
// #if DIM3
export enum FeatureType {
    Vertex,
    Edge,
    Face,
    Unknown,
}
// #endif
